import { Button, ButtonGroup, Card, SegmentedControl } from "@blueprintjs/core";
import { useLocation, useNavigate } from "react-router";
import {
  ITEM_GRID_PATH_NEW,
  SidebarEntryPath,
} from "../../../../constants/contants";
import {
  setSchedulerArgsCreate,
  setSchedulerSelectedEventId,
} from "../../../../store/slices/slice-scheduler";
import { useAppDispatch } from "../../../../store/store";

const VIEW_OPTIONS = [
  { value: "dayGridMonth", label: "Month" },
  { value: "timeGridWeek", label: "Week" },
  { value: "timeGridDay", label: "Day" },
  { value: "listMonth", label: "List" },
];

type SchedulerHeaderProps = {
  title: string;
  view: string;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  onChangeView: (view: string) => void;
};

export function SchedulerHeader({
  onChangeView,
  onNext,
  onPrev,
  onToday,
  title,
  view,
}: SchedulerHeaderProps) {
  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    // Same header shell as every other panel (ItemGridToolbar,
    // HeaderCreateEdit, MediaGridToolbar): `Card compact elevation={1}` +
    // a `bp6-heading` title. The calendar needs extra prev/next/today/view
    // controls the generic toolbar doesn't have, so this stays a bespoke
    // component -- but it should still read as the same product.
    <Card compact elevation={1}>
      <div className="flex flex-row flex-wrap items-center gap-4">
        <div className="flex items-center gap-3">
          <ButtonGroup>
            <Button
              aria-label="Previous"
              icon="chevron-left"
              minimal
              onClick={onPrev}
            />
            <Button outlined onClick={onToday} text="Today" />
            <Button
              aria-label="Next"
              icon="chevron-right"
              minimal
              onClick={onNext}
            />
          </ButtonGroup>
          <h4 className="m-0 content-center bp6-heading">{title}</h4>
        </div>
        <div className="flex flex-1 items-center justify-end gap-3">
          <SegmentedControl
            onValueChange={onChangeView}
            options={VIEW_OPTIONS}
            value={view}
          />
          <Button
            icon="new-object"
            intent="primary"
            onClick={() => {
              dispatch(setSchedulerSelectedEventId());
              dispatch(setSchedulerArgsCreate());
              navigate(
                `/${SidebarEntryPath.scheduler}/${ITEM_GRID_PATH_NEW}${search}`,
              );
            }}
            text="Create Event"
          />
        </div>
      </div>
    </Card>
  );
}
